var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"game"}},[(_vm.gameData)?_c('iframe',{attrs:{"src":_vm.statisticsSrc,"id":"myIframe"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }